import { useFeatureSwitchList } from '@src/data/api/credit-api/credit-api'
import { getFeatureFlags } from '@src/data/config-selectors'
import { useMemo } from 'react'

const useFeatureFlags = () => {
  const [featureSwitchInfo, isFetchingFeatureSwitch] = useFeatureSwitchList()

  const flags = useMemo(() => {
    const featureFlags = getFeatureFlags(featureSwitchInfo?.featureSwitches || [])
    return featureFlags
  }, [featureSwitchInfo])

  return { flags, isFetchingFeatureSwitch }
}

export default useFeatureFlags
